export default __webpack_public_path__ + "static/Banner-Galentine-1-99449bae916a4763688d11875cd5f4bc.jpg";